import Attendances from './Requests/Attendances';
import Auth from './Requests/Auth';
import CustomerForms from './Requests/CustomerForms';
import CustomerFormSubmissions from './Requests/CustomerFormSubmissions';
import CustomerMemberships from './Requests/CustomerMemberships';
import CustomerFields from './Requests/CustomerFields';
import CustomerFieldsValues from './Requests/CustomerFieldsValues';
import CustomerCredits from './Requests/Reports/CustomerCredits';
import Customers from './Requests/Customers';
import Events from './Requests/Events';
import Instructors from './Requests/Instructors';
import Memberships from './Requests/Memberships';
import Penalties from './Requests/Penalties';
import Policies from './Requests/Policies';
import PolicyAgreements from './Requests/PolicyAgreements';
import Providers from './Requests/Providers';
import RegistrationEligibility from './Requests/RegistrationEligibility';
import Venues from './Requests/Venues';
import Waivers from './Requests/Waivers';
import WaiverAgreements from './Requests/WaiverAgreements';
import { getCookie, setCookie, deleteCookie } from '../../../tools/cookies';

/**
 * @param {string} endpoint
 * @param {string} requestMode
 * @param {string} providerId
 * @param {string} customerId
 * @param {boolean} auth
 * @param {boolean} fowardRequest
 */
export function getTeamUpAPI(
    endpoint = '',
    requestMode = 'customer',
    providerId = '',
    customerId = '',
    auth = true,
    fowardRequest = false,
) {
    let api = null;
    switch (endpoint) {
        case 'Attendances':
            api = new Attendances(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'Auth':
            api = new Auth(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'CustomerForms':
            api = new CustomerForms(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'CustomerFormSubmissions':
            api = new CustomerFormSubmissions(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'CustomerFields':
            api = new CustomerFields(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'CustomerFieldsValues':
            api = new CustomerFieldsValues(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'CustomerMemberships':
            api = new CustomerMemberships(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'CustomerMemberships':
            api = new CustomerMemberships(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'CustomerCredits':
            api = new CustomerCredits(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'Customers':
            api = new Customers(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'Events':
            api = new Events(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'Instructors':
            api = new Instructors(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'Memberships':
            api = new Memberships(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'Penalties':
            api = new Penalties(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'Policies':
            api = new Policies(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'PolicyAgreements':
            api = new PolicyAgreements(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'Providers':
            api = new Providers(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'RegistrationEligibility':
            api = new RegistrationEligibility(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'Venues':
            api = new Venues(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'WaiverAgreements':
            api = new WaiverAgreements(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        case 'Waivers':
            api = new Waivers(
                requestMode,
                providerId,
                customerId,
                auth,
                fowardRequest,
            );
            break;
        default:
            api = null;
            break;
    }

    return api;
}

/**
 * Sets the selected studio name and ids
 *
 * @param {string} name
 * @param {string} id
 * @param {string} providerId
 * @param {string} venueId
 * @param {string|boolean} customerId
 * @param {boolean} updateActive
 * @returns {Void}
 */
export async function changeSelectedStudio(
    name = '',
    id = '',
    providerId = '',
    venueId = '',
    customerId = '',
    updateActive = true,
) {
    if (customerId == '' && customerId !== false) {
        customerId = await getTeamProviderCustomerId(providerId);
    }

    setCookie('selected-studio-name', name, 30);
    setCookie('selected-studio-id', id, 30);
    setCookie('team-up-provider-id', providerId, 30);
    setCookie('team-up-venue-id', venueId, 30);

    if (customerId != '' && customerId !== false) {
        setCookie('team-up-customer-id', customerId, 30);
    }

    if (updateActive) {
        const studioUrl = await fetchStudioUrl(id);

        // Update the active studio cookies if update flag is true
        setCookie('active-studio-name', name, 90);
        setCookie('active-studio-id', id, 90);

        if (studioUrl !== '') {
            setCookie('active-studio-url', studioUrl, 90);
        } else {
            deleteCookie('active-studio-url');
        }

        updateStudioLinks();
    }
}

/**
 * Fetches the permalink of a studio from our own API
 *
 * @param {string} id
 * @returns {Promise<string>} The url, or an empty string if it couldn't be fetched
 */
export async function fetchStudioUrl(id = '') {
    try {
        const studioRequest = await fetch(
            `${process.env.WEB_API_ENDPOINT}studios/${id}`,
            {
                method: 'GET',
                headers: {
                    Authorization: `Basic ${process.env.WEB_API_TOKEN}`,
                },
            },
        );

        const studioResponse = await studioRequest.json();

        if (
            typeof studioResponse === 'object' &&
            studioResponse?.id == id &&
            isSameSiteUrl(studioResponse?.url)
        ) {
            return studioResponse.url;
        }

        console.log(`Error fetching studio data for studio id: ${id}`);
    } catch (error) {
        console.log(`${process.env.WEB_API_ENDPOINT}studios/${id}: ${error}`);
    }

    return '';
}

/**
 * Sets every studio button (views/partials/components/studio-link.twig) from the
 * visitor's own cookies.
 *
 * The page cache doesn't vary on the TeamUp cookies, so the server-rendered
 * button can belong to whoever primed the cache: "Find a studio" for a member,
 * or another member's studio for a visitor. This mirrors the template's logic
 * client-side so every visitor sees their own state.
 *
 * @returns {Void}
 */
export function updateStudioLinks() {
    const studioName = getActiveStudioName();
    const studioUrl = getActiveStudioUrl();
    const hasActiveStudio = getActiveStudioId() !== '' && studioName !== '';

    let text = 'Find a studio';
    let href = window.location.pathname.startsWith('/sign-up')
        ? '/studios/?return_to=/sign-up/'
        : '/studios/';

    if (hasActiveStudio) {
        // Decode entities the way the template's raw output would, without
        // letting a cookie inject markup
        const name = new DOMParser().parseFromString(studioName, 'text/html')
            .documentElement.textContent;

        text = `Book at ${name}`;
        // Without a saved url, leave the link where the page had it
        href = studioUrl !== '' ? `${studioUrl}schedule/` : '';
    } else if (isTeamUpLoggedIn()) {
        text = 'Select a studio';
        href = '/my-account/?tab=studios';
    }

    document
        .querySelectorAll('.button--studio-find .button__studio-name')
        .forEach((studioBtn) => {
            studioBtn.textContent = text;

            if (href !== '') {
                studioBtn.parentElement.setAttribute('href', href);
            }
        });

    document.body.classList.toggle('has-active-studio', hasActiveStudio);
}

/**
 * @param {string} url
 * @returns {boolean}
 */
function isSameSiteUrl(url = '') {
    if (typeof url !== 'string' || url === '') {
        return false;
    }

    try {
        return (
            new URL(url, window.location.origin).origin ===
            window.location.origin
        );
    } catch (error) {
        return false;
    }
}

export function removeSelectedStudio() {
    deleteCookie('selected-studio-name');
    deleteCookie('selected-studio-id');
    deleteCookie('team-up-provider-id');
    deleteCookie('team-up-venue-id');
}

/**
 * Gets the selected studio name
 *
 * @returns {string}
 */
export function getSelectedStudioName() {
    return decodeURI(getCookie('selected-studio-name') ?? '');
}

/**
 * Gets the selected studio id
 *
 * @returns {string}
 */
export function getSelectedStudioId() {
    return getCookie('selected-studio-id') ?? '';
}

/**
 * Gets the active studio name
 *
 * @returns {string}
 */
export function getActiveStudioName() {
    return decodeURI(getCookie('active-studio-name') ?? '');
}

/**
 * Gets the active studio id
 *
 * @returns {string}
 */
export function getActiveStudioId() {
    return getCookie('active-studio-id') ?? '';
}

/**
 * Gets the active studio url, saved alongside the id when the studio is picked
 *
 * @returns {string}
 */
export function getActiveStudioUrl() {
    const url = getCookie('active-studio-url') ?? '';
    return isSameSiteUrl(url) ? url : '';
}

/**
 * Checks to see if user has logged into Team Up
 *
 * @returns {boolean}
 */
export function isTeamUpLoggedIn() {
    return getTeamUpAccessToken() != '';
}

/**
 * Gets the Team Up access token
 *
 * @returns {boolean}
 */
export function getTeamUpAccessToken() {
    return getCookie('team-up-access-token') ?? '';
}

/**
 * Gets the Team Up refresh token
 *
 * @returns {boolean}
 */
export function getTeamUpRefreshToken() {
    return getCookie('team-up-refresh-token') ?? '';
}

/**
 * Gets the Team Up token expiry
 *
 * @returns {boolean}
 */
export function getTeamUpTokenExpiry() {
    return getCookie('team-up-token-expires') ?? '';
}

/**
 * Gets the Team Up provider id
 *
 * @returns {string}
 */
export function getTeamProviderId() {
    return getCookie('team-up-provider-id') ?? '';
}

/**
 * Gets the Team Up customer id
 *
 * @returns {string}
 */
export function getTeamCustomerId() {
    return getCookie('team-up-customer-id') ?? '';
}

/**
 * Gets the Team Up customer id based on provider id
 *
 * @param {string} providerId
 * @returns {string}
 */
export async function getTeamProviderCustomerId(providerId = '') {
    let customerId = '';
    if (isTeamUpLoggedIn()) {
        if (providerId !== '') {
            const auth = getTeamUpAPI('Auth', 'customer');
            let { results } = await auth.profile(providerId);

            if (results.length > 0) {
                const firstProfileKey = Object.keys(results)[0];
                const firstProfile = results[firstProfileKey];
                if ('id' in firstProfile) {
                    customerId = firstProfile.id;
                }
            }
        } else {
            customerId = getTeamCustomerId();
        }
    }

    return customerId;
}

/**
 * Gets the Team Up venue id
 *
 * @returns {string}
 */
export function getTeamVenueId() {
    return getCookie('team-up-venue-id') ?? '';
}

/**
 * Gets error for a field
 *
 * @param {string} fieldKey
 * @param {array} errors
 * @returns {string}
 */
export function getTeamUpFieldError(fieldKey = '', errors = []) {
    let errorMessage = '';
    if (errors.length > 0) {
        const fieldError = errors.find((error) => error.field === fieldKey);

        if (fieldError) {
            errorMessage = fieldError?.message;
            if (fieldKey === 'referral_code') {
                // TeamUp's own copy doesn't distinguish referral codes from
                // checkout discount codes, which is the main reason customers
                // hit this error.
                errorMessage =
                    'Invalid code. If this is a referral code, check you’re using it for the correct studio. If it’s a discount for a free class, enter it at checkout instead.';
            } else if (errorMessage === 'Invalid username or password') {
                errorMessage = 'Incorrect password and/or email';
            } else if (errorMessage === 'This field may not be blank.') {
                if (fieldKey === 'username') {
                    errorMessage = 'Email required';
                } else if (fieldKey === 'password') {
                    errorMessage = 'Password required';
                }
            }
        }
    }

    return errorMessage;
}

export const PURCHASE_FAILED_MESSAGE =
    "We couldn't start this purchase. Please try again or contact the studio.";

/**
 * Errors from a purchase request, ready to show.
 *
 * TeamUp refuses a purchase with a code and a message rather than a field
 * error, and HTTPRequest keeps those in `errors` only (field errors land in
 * both). Checking fieldErrors alone let a refusal through as "no checkout
 * link": registration sent the customer back to return_to with nothing said,
 * and the passes page simply did nothing.
 *
 * Normalised to non_field_errors so a form's error slot shows them. A failed
 * request carries the thrown error as its message, which React cannot render,
 * so anything that isn't text falls back to a generic message.
 *
 * @param {object} response
 * @return {array}
 */
export function getPurchaseErrors(response) {
    return (response?.errors ?? []).map((error) => ({
        field: 'non_field_errors',
        message:
            typeof error?.message === 'string' && error.message !== ''
                ? error.message
                : PURCHASE_FAILED_MESSAGE,
    }));
}

/**
 * Gets the customer field from list of custom fields
 *
 * @param {string} fieldKey
 * @param {array} fields
 * @returns {object}
 */
export function getTeamUpCustomerField(fieldName = '', fields = []) {
    let customerField = null;
    if (fields.length > 0) {
        customerField = fields.find((field) => field.key === fieldName);
    }

    return customerField;
}

/**
 * Gets the customer field value from list of custom fields
 *
 * @param {string} fieldKey
 * @param {array} fields
 * @returns {object}
 */
export function getTeamUpCustomerFieldValue(fieldName = '', fields = []) {
    let customerField = null;

    if (fields.length > 0) {
        customerField =
            fields.find((field) => field.field.key === fieldName) ?? null;
    }

    return customerField;
}

/**
 * @param {string} returnTo
 * @param {object} query
 * @return {string}
 */
export function getTeamUpReturnUrl(returnTo = '', query = {}) {
    if (returnTo == '') {
        returnTo = process.env.TEAM_UP_CHECKOUT_SUCCESS_PAGE;
    }

    let returnToUrl = new URL(returnTo);
    if (Object.keys(query).length > 0) {
        for (const key in query) {
            if (query[key] != '') {
                returnToUrl.searchParams.set(key, query[key]);
            }
        }
    }

    return returnToUrl.toString();
}

/**
 * Membership classification.
 *
 * Every list of memberships in the theme decides what to show by category
 * name or by a word in the membership's own name. Those tests were written
 * out longhand at each call site, which is how the Memberships tab in the
 * booking flow ended up missing three of them and offering hidden offers for
 * sale. They live here now so there is one definition to keep right.
 *
 * `category` is an expanded relation, so it is absent on any membership that
 * has none. Reading `.name` straight off it throws on whichever branch of a
 * filter evaluates it, taking the whole list down with it, so the helpers
 * read it defensively.
 *
 * @param {object} membership
 * @return {string}
 */
export function getMembershipCategoryName(membership) {
    return (membership?.category?.name ?? '').toLowerCase();
}

/**
 * @param {object} membership
 * @return {string}
 */
export function getMembershipName(membership) {
    return (membership?.name ?? '').toLowerCase();
}

/**
 * Hidden offers belong to the studio's own hidden offers tab and must never
 * appear anywhere a customer can buy from.
 *
 * @param {object} membership
 * @return {boolean}
 */
export function isHiddenMembership(membership) {
    return getMembershipCategoryName(membership) === 'hidden offers';
}

/**
 * @param {object} membership
 * @return {boolean}
 */
export function isGiftVoucherMembership(membership) {
    return getMembershipCategoryName(membership) === 'gift vouchers';
}

/**
 * @param {object} membership
 * @return {boolean}
 */
export function isSpecialMembership(membership) {
    return getMembershipCategoryName(membership) === 'special';
}

/**
 * @param {object} membership
 * @return {boolean}
 */
export function isWorkshopMembership(membership) {
    return getMembershipName(membership).includes('workshop');
}

/**
 * Studios name these inconsistently, so 'intro-offer' is normalised to
 * 'intro offer' before matching.
 *
 * @param {object} membership
 * @return {boolean}
 */
export function isIntroOfferMembership(membership) {
    return getMembershipName(membership)
        .replace('intro-offer', 'intro offer')
        .includes('intro offer');
}

/**
 * The usage periods worth showing on a pass.
 *
 * TeamUp reports usage as one period per limit a pass carries. A 10 Class
 * Pass capped at 5 a day comes back as a `day` period (5 of 5) followed by a
 * `lifetime` period (10 of 10), so reading the periods in order put the daily
 * cap in front of the pass. Hotpod don't want the daily cap shown at all, and
 * TeamUp still enforces it at booking. A pass with an overall total shows only
 * that total. Anything without one keeps its weekly or monthly allowance. The
 * app reads them the same way, and the booking confirmation page mirrors this
 * in Utilities::getDisplayUsagePeriod().
 *
 * Periods without a count (unlimited) are dropped.
 *
 * @param {array} usagePeriods
 * @return {array}
 */
export function getDisplayUsagePeriods(usagePeriods = []) {
    const countedPeriods = (usagePeriods ?? []).filter(
        (usagePeriod) =>
            parseInt(usagePeriod?.remaining_count) >= 0 &&
            parseInt(usagePeriod?.max_uses) >= 0,
    );
    const lifetimePeriod = countedPeriods.find(
        (usagePeriod) => usagePeriod.period_type === 'lifetime',
    );

    if (lifetimePeriod) {
        return [lifetimePeriod];
    }

    return countedPeriods.filter(
        (usagePeriod) => usagePeriod.period_type !== 'day',
    );
}

/**
 * @param {object} membership
 * @return {mixed}
 */
export function getFirstAvailableMembershipPlan(membership) {
    const firstAvailablePlan =
        membership.plans.find((plan) => plan.status === 'for_sale') ?? null;

    if (!firstAvailablePlan) {
        return false;
    }

    return firstAvailablePlan;
}

/**
 * @param {object} membership
 * @return {mixed}
 */
export function getPlanId(membership) {
    const availablePlan = getFirstAvailableMembershipPlan(membership);

    return availablePlan?.id ?? null;
}

/**
 * @param {object} membership
 * @return {string}
 */
export function getMembershipPrice(membership, includePeriod = false) {
    let membershipPrice = '';
    let billingLength = 0;
    let billingPeriod = '';
    if (membership.type == 'recurring_plan') {
        const firstAvailablePlan = getFirstAvailableMembershipPlan(membership);
        if (firstAvailablePlan) {
            membershipPrice = firstAvailablePlan?.price_with_period ?? '';
            // remove ' per month' (with leading space) from membership price
            membershipPrice = membershipPrice.replace(/ per month$/, '');
            billingLength = firstAvailablePlan?.billing_period_length ?? 0;
            billingPeriod = firstAvailablePlan?.billing_period_unit ?? '';
        }
    } else {
        membershipPrice = membership?.display_price?.string ?? '';
        billingLength = membership?.duration ?? 0;
        billingPeriod = membership?.duration_unit ?? '';
    }

    if (includePeriod && billingPeriod != '') {
        // get billing period string from billing_period_unit but remove ending s from string if present.
        if (billingLength == 1) {
            billingPeriod = billingPeriod.replace(/s$/, '');
        }

        membershipPrice += ' /';
        if (billingLength > 1) {
            membershipPrice += ` ${billingLength}`;
        }
        membershipPrice += ` ${billingPeriod}`;
    }

    return membershipPrice.replace('.00', '');
}

/**
 * @param {object} membership
 * @return {string}
 */
export function getMembershipPriceFrequency(membership) {
    let membershipFrequency = '';
    let billingLength = 0;
    let billingPeriod = '';
    if (membership.type == 'recurring_plan') {
        const firstAvailablePlan = getFirstAvailableMembershipPlan(membership);

        billingLength = firstAvailablePlan?.billing_period_length ?? 0;
        billingPeriod = firstAvailablePlan?.billing_period_unit ?? '';
    } else {
        billingLength = membership?.duration ?? 0;
        billingPeriod = membership?.duration_unit ?? '';
    }

    if (billingLength == 1) {
        billingPeriod = billingPeriod.replace(/s$/, '');
    }

    if (billingLength > 1) {
        membershipFrequency += `${billingLength}`;
    }
    membershipFrequency += ` ${billingPeriod}`;

    return membershipFrequency;
}

/**
 * Gets the current customer's first name from cookie if set
 *
 * @returns {string}
 */
export function getCustomerFirstName() {
    return getCookie('team-up-customer-first-name') ?? '';
}

/**
 * Sets the current customer's first name in cookie
 *
 * @param {string} firstName
 * @returns {void}
 */
export function setCustomerFirstName(firstName = '') {
    setCookie('team-up-customer-first-name', firstName, 30);
}
